import React, {useState} from 'react'
import {toast} from 'react-toastify'
import {
  Actions,
  BrandSection,
  Header,
  LogoMark,
  SendActionWrap,
  Subtitle,
  Title,
  TitleGroup,
} from './ProductsCatalogHeader.styles'
import {Button} from '../../../../../../core/shared/Button'
import {Spinner} from '../../../../../../core/shared/Button/Button.styles'
import {ButtonGroup} from '../../../../../../core/shared/ButtonGroup'
import Icon from '../../../../../../core/shared/Icon'
import {SendProposalModal} from '../ProposalSendModal'
import {useSelector} from 'react-redux'
import {
  selectProposalInfo,
  selectIsDirty,
} from '../../../../../../app-store/ProposalSlice'

// ─── Default icons ────────────────────────────────────────────────────────────

// ── Component ─────────────────────────────────────────────────────────────────

export default function ProductCatalogHeader({
  title = 'Product Catalog',
  onBack,
  onPreview,
  onSave,
  onSendProposal,
  isPreviewLoading = false,
  isSaveLoading = false,
}) {
  const [isSendProposalModalOpen, setSendProposalModalStatus] = useState(false)
  const [hasSaved, setHasSaved] = useState(false)
  const handleSendProposalModalStatus = () => {
    setSendProposalModalStatus(false)
  }
  const proposalInfo = useSelector(selectProposalInfo)
  const isDirty = useSelector(selectIsDirty)
  const companyName = proposalInfo?.businessName
  const email = proposalInfo?.clientEmail

  const handleSave = () => {
    onSave?.()
    setHasSaved(true)
  }

  const isSendDisabled =
    !hasSaved ||
    !proposalInfo?.proposalLink ||
    isDirty ||
    isSendProposalModalOpen

  // Clicking the greyed-out button should explain why it is unavailable
  // instead of doing nothing.
  const handleSendAreaClick = () => {
    if (!isSendDisabled) {
      setSendProposalModalStatus(true)
      return
    }
    // The modal is already open — nothing to explain.
    if (isSendProposalModalOpen) return

    const message =
      hasSaved && isDirty
        ? 'You have unsaved changes. Save the proposal before sending it.'
        : 'Please save the proposal before sending it.'

    toast.info(message, {toastId: 'send-proposal-save-first'})
  }

  return (
    <Header>
      <BrandSection>
        <LogoMark aria-hidden="true">
          <Icon name="product-catalog" size="md" />
        </LogoMark>
        <TitleGroup>
          <Title>{title}</Title>
          <Subtitle>
            {companyName}
            {email && <span> | {email}</span>}
          </Subtitle>
        </TitleGroup>
      </BrandSection>

      {/* ── Right: actions ── */}
      <Actions>
        <Button variant="primary-blue" size="xs" onClick={onBack}>
          <Icon name="backArrow" size="sm" color="#5378FC" />
          <span>Back</span>
        </Button>
        <ButtonGroup
          buttons={[
            {
              label: 'Preview',
              icon: isPreviewLoading ? (
                <Spinner />
              ) : (
                <Icon name="view" size="xs" color="#000000" />
              ),
              disabled: isPreviewLoading,
              onClick: onPreview,
            },
            {
              label: 'Save',
              icon: isSaveLoading ? (
                <Spinner />
              ) : (
                <Icon name="save" size="xs" color="#000000" />
              ),
              disabled: isSaveLoading,
              onClick: handleSave,
            },
          ]}
        />
        <SendActionWrap
          isDisabled={isSendDisabled}
          onClick={handleSendAreaClick}
        >
          <Button
            variant="solid-dark-blue-pill"
            size="sm"
            disabled={isSendDisabled}
          >
            <Icon name="send" size="xs" color="#ffffff" />
            <span>Send Proposal</span>
          </Button>
        </SendActionWrap>
      </Actions>
      <SendProposalModal
        isSendProposalModalOpen={isSendProposalModalOpen}
        handleSendProposalModalStatus={handleSendProposalModalStatus}
        onSendProposal={onSendProposal}
      />
    </Header>
  )
}
